module.exports = __webpack_public_path__ + "static/media/vue.3169a04f.png";